module.exports = __webpack_public_path__ + "static/media/weather-app.4dd8aa5d.png";